// src/lib/datetime.js
export function toApiDateTime(input) {
  if (!input) return "";

  const value = String(input).trim();
  const match = value.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2}:\d{2})/);

  if (match) {
    return `${match[1]} ${match[2]}`;
  }

  return value;
}

export function toLocalDateTime(input, opts = {}) {
  if (!input) return "";

  // Normalize common backend formats:
  // - "YYYY-MM-DD HH:mm:ss"  (no timezone)
  // - "YYYY-MM-DDTHH:mm:ssZ" (ISO)
  // - "YYYY-MM-DDTHH:mm:ss+11:00" (ISO with offset)
  let s = String(input).trim();

  // If it's "YYYY-MM-DD HH:mm:ss", convert to ISO-like.
  // Note: without timezone info, this will be interpreted as LOCAL time.
  if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(s)) {
    s = s.replace(" ", "T");
  }

  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(input);

  const locale = opts.locale; // undefined => browser locale
  const timeZone = opts.timeZone; // undefined => browser local timezone

  const dateStyle = opts.dateStyle ?? "medium";
  const timeStyle = opts.timeStyle ?? "short";

  return new Intl.DateTimeFormat(locale, {
    timeZone,
    dateStyle,
    timeStyle,
  }).format(d);
}

